import {
  ListItemIcon,
  Typography,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowRight } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { clearAllPaginationState } from '../../utils/helpers';
import { useSecondaryMenu } from '../../hooks/useMenuTree';

const SecondarySidebarLayout = styled('div', {
  shouldForwardProp: (prop) => prop !== 'drawerstate' && prop !== 'theme',
})(({ theme, drawerstate }) => {
  return {
    position: 'fixed',
    zIndex: 500,
    top: 65,
    left: 72,
    marginTop: 0,
    height: 'calc(100vh - 65px)',
    width: drawerstate ? 200 : 0,
    overflow: drawerstate ? 'visible' : 'hidden',
    overflowY: 'auto',
    transitionDelay: '.2s,.2s,0s',
    transition: theme.transitions.create(
      ['background', 'height', 'width', 'box-shadow', 'overflow'],
      {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      },
    ),
    // boxShadow: drawerstate ? "1px 1px 12px #dadce0" : null,
  };
});

const getFirstTwoSegments = (path) => path?.split('/').slice(1, 3).join('/');

function SecondaryMenu() {
  const location = useLocation();
  const { selectedMenu, parentMenuItem, isSecondaryMenuOpen } = useSecondaryMenu();

  return (
    <SecondarySidebarLayout
      drawerstate={isSecondaryMenuOpen}
      className="py-3 bg-white border-end"
    >
      {selectedMenu.length > 0 && (
        <>
          <Typography variant="overline" className="p-3">
            {parentMenuItem?.name}
          </Typography>

          <List>
            {selectedMenu.map((item) => (
              <List key={item._id} className="py-0">
                <Link
                  to={item?.url ? item.url : '/not-found'}
                  onClick={() => clearAllPaginationState()}
                  style={{
                    textDecoration: 'inherit',
                    color: 'inherit',
                  }}
                >
                  <ListItemButton
                    className="py-1"
                    selected={
                      getFirstTwoSegments(location.pathname) ===
                      getFirstTwoSegments(item?.url)
                    }
                    sx={{
                      borderTopRightRadius: 50,
                      borderBottomRightRadius: 50,
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      <ArrowRight />
                    </ListItemIcon>
                    <ListItemText primary={item?.name} />
                  </ListItemButton>
                </Link>
              </List>
            ))}
          </List>
        </>
      )}
    </SecondarySidebarLayout>
  );
}

export default SecondaryMenu;